module.exports = __webpack_public_path__ + "static/media/10441111_797997176891174_3924050268409755808_n.b3883445.jpg";